import React from "react";

import {
	recountTotal, tempDataPage
} from "./commonMobile";

import {
	IGameType,
	IUnsubmittedTicket,
	IRunningTicketType,
	IGameObjectType,
	ILanguageType
} from "@/types/GlobalTypes";
import nullArray from "./nullArray";

/**
 * RaceBall/Shio Balls top row
 */
function activateBetGroup(e: React.MouseEvent) {
	const
		pcode = e.currentTarget.getAttribute("pcode"),
		group = e.currentTarget.getAttribute("group"),
		{ games } = this.state;

	games[pcode].activeBetGroup = group;

	this.setState({ games });
}


/**
 * Add rows, linked to addUnsubmittedTicketRowNotDom()
 * Usage: bound to DOM
 * @param e
 */
function addUnsubmittedTicketRow(e: React.MouseEvent) {
	const pcode = e.currentTarget.getAttribute("pcode");
	const { games } = this.state;
	const game = games[pcode];

	addUnsubmittedTicketRowNotDom(game, true);

	this.checkController(game);
	this.setState({ games });
}

//game: game object
//addBetHistory: boolean
function addUnsubmittedTicketRowNotDom(game: IGameType, addBetHistory: boolean) {
	let groups: string[];

	//Adds 10 tickets every call
	switch (game.pcode) {
		case "m29":
			groups = ["c3set", "c1d1", "c2d1", "c3d1", "d1", "d2", "d3", "3dset"];

			game.groupedUnsubmittedTickets = {};

			groups.forEach((group: string) => {
				game.groupedUnsubmittedTickets[group] = [];

				for (let a = 0; a < 10; a++)
					game.groupedUnsubmittedTickets[group].push({ bet: 0, animals: nullArray(3) });
			});

			break;

		case "m26":
			groups = ["random", "order"];
			game.groupedUnsubmittedTickets = {};

			groups.forEach((group: string) => {
				game.groupedUnsubmittedTickets[group] = [];

				for (let a = 0; a < 10; a++)
					game.groupedUnsubmittedTickets[group].push({ bet: 0, numbers: nullArray(9) });
			});

			break;

		case "m30":
			groups = ["50-50", "c5set", "c1d1", "c2d1", "c3d1", "c4d1", "c5d1", "d1", "d2", "d3", "d4", "d5", "5dset"];
			game.groupedUnsubmittedTickets = {};

			groups.forEach((group: string) => {
				game.groupedUnsubmittedTickets[group] = [];

				for (let a = 0; a < 10; a++)
					game.groupedUnsubmittedTickets[group].push({ bet: 0, numbers: nullArray(5) });
			});

			break;

		case "m42":
			if (!game.unsubmittedTickets)
				game.unsubmittedTickets = [];

			for (let a = 0; a < 10; a++)
				game.unsubmittedTickets.push({
					numbers: nullArray(2),
					bet: 0
				});

			break;

		default: break;
	}

	if (addBetHistory)
		game.betHistory.push({
			type: "newUnsubmittedTicketRow10",
			betGroup: game.activeBetGroup
		});
}

function removeBet(e: any) {
	const pcode = e.currentTarget.getAttribute("pcode");
	const unsubmittedTicketIdx = e.currentTarget.getAttribute("ticketindex");

	const games: IGameObjectType = this.state.games;
	const game = games[pcode];

	const group = e.currentTarget.getAttribute("group");

	if (game.activeBetGroup === "50-50") {
		const betKey = e.currentTarget.getAttribute("betkey");

		//Push bet history like old games
		game.betHistory.push({
			key: betKey,
			value: -game.bet[betKey]
		});

		game.bet[betKey] = 0;
	} else if (game.unsubmittedTickets) {
		// Machine game without groups
		const ticket = game.unsubmittedTickets[unsubmittedTicketIdx];

		// Pinball
		game.betHistory.push({
			type: "removeBet",
			betGroup: group,
			unsubmittedTicketIdx,
			bet: ticket.bet
		});

		ticket.bet = 0;
	} else {
		// Machine game with groups
		const ticket = game.groupedUnsubmittedTickets[group][unsubmittedTicketIdx];

		game.betHistory.push({
			type: "removeBet",
			betGroup: group,
			unsubmittedTicketIdx,
			bet: ticket.bet
		});

		ticket.bet = 0;
	}

	recountTotal(game);
	this.checkController(game); //removeBet
	this.setState({ games });

	//Stops event from bubbling
	e.stopPropagation();
}


// Unsubmitted Tickets
// Fill with empty tickets on opening for the first time

//	skipClearUnsubmittedTickets is set when fetch("/games/send/send")
function fillEmptyUnsubmittedTickets(game: IGameType) {
	// Fills 20 tickets in a row
	for (let a = 0; a < 2; a++)
		addUnsubmittedTicketRowNotDom(game, false);
}

function hasUnsubmittedTickets(unsubmittedTicketArray: IUnsubmittedTicket[]) {
	return unsubmittedTicketArray.some((item: IUnsubmittedTicket) =>
		((item.numbers || item.animals) as any[]).filter(num => num !== null).length > 0 ||
		item.bet > 0
	);
}

function activateUnsubmittedTicketRow(e: React.MouseEvent) {
	const rowIdx = e.currentTarget.getAttribute("rowidx");
	const pcode = e.currentTarget.getAttribute("pcode");

	const games = this.state.games;
	const group = e.currentTarget.getAttribute("group");

	games[pcode].activeUnsubmittedTicketRow = Number(rowIdx);

	if (group)
		games[pcode].activeBetGroup = group; //activeBetGroupByTicketRow	

	this.setState({ games: games });
}


function fetchTicketHistory(mainClass: any, pcode: string, gamePeriod: number | string) {
	if (!pcode || !pcode.length) {
		console.error("fTH pcode is empty");
		return;
	}

	if (!mainClass.state.games[pcode])
		return;

	const request = (mainClass.state.useTempData) ?
		new Request(tempDataPage + "?page=ticket-game-" + pcode) :
		new Request("/games/ticket-game/" + pcode + "/" + gamePeriod);

	let init: RequestInit;
	if (!mainClass.state.useTempData)
		init = { credentials: "same-origin" };

	//Fetch game list
	fetch(request, init)
		.then(res => res.json())
		.then(tickets => {
			const _games = mainClass.state.games;
			const game = _games[pcode];

			game.lastPeriodTickets = tickets;
			game.disableRebet = false;

			recountTotal(game);

			mainClass.setState({ games: _games });
		})
		.catch(error =>
			console.error("Failed to fetch ticket history", error)
		);
}

//Same as above, but instead also applies tickets
//Triggered when the user leaves the page, then reopens the game again.
//Parameters:
//  mainClass: Lobby or MaximizeMobileGame Component
//  game: game object from fetchGameList()
//  callback: callback function when fetch request is successful
function fetchApplyTickets(mainClass: any, game: IGameType, callback: () => void | undefined) {
	const request = (mainClass.state.useTempData) ?
		new Request(tempDataPage + "?page=current-ticket-game-" + game.pcode) :
		new Request("/games/ticket-game/" + game.pcode + "/" + game.periode);

	let init: RequestInit;
	if (!mainClass.state.useTempData)
		init = { credentials: "same-origin" };

	//Fetch game list
	fetch(request, init)
		.then(res => res.json())
		.then(tickets => {
			//console.log("fAT tickets", tickets);
			game.tickets = (!tickets) ? [] : tickets;
			game.disableRebet = false;

			//Similar: see commonM26.js > pushM26Tickets()
			if (callback)
				callback();
		})
		.catch(error =>
			// alert("Failed to fetch game list, please try again later.");
			console.error(error)
		);
}

function applyTicketRebet(game: IGameType) {
	if (!game.lastPeriodTickets ||
		game.lastPeriodTickets.length === 0) return;

	game.tickets = game.lastPeriodTickets.slice(0) as IRunningTicketType[];
	game.tickets.forEach(ticketItem => {
		//Changes periode to current game periode
		ticketItem.periode = game.periode;
	});

	//- Used in a Submit button condition where it will force the user to submit tickets first
	//- Enables the user to remove unwanted tickets
	game.mustSubmitTickets = true; //Todo: debug this later
}

function countTickets(game: IGameType) {
	if (!game.tickets)
		return;

	//Reset ticket count
	game.ticketCounts = {};

	// console.log("tickets", game.tickets);

	game.tickets.forEach(item => {
		if (!game.ticketCounts[item.type])
			game.ticketCounts[item.type] = 0;

		game.ticketCounts[item.type]++;
	});

	// Special 50-50 tickets
	if (game.bet && game.ticketCounts["n50"]) {
		game.ticketCounts["50-50"] = game.ticketCounts["n50"];
		delete game.ticketCounts["n50"];
	}
}

//After click Rebet
function removeTicket(e: any) {
	//Removes bets on betting panel then recount total

	const pcode = e.currentTarget.getAttribute("pcode");
	const index = e.currentTarget.getAttribute("index");
	const _games = this.state.games;
	const game = _games[pcode];

	const removedTicket = game.tickets.splice(index, 1)[0];

	game.bet["+" + removedTicket.type] -= removedTicket.bayar;
	if (game.bet["+" + removedTicket.type] <= 0 ||
		isNaN(game.bet["+" + removedTicket.type]))
		delete game.bet["+" + removedTicket.type];

	recountTotal(game);

	if (game.tickets.length === 0)
		game.mustSubmitTickets = false;

	this.checkController(game);

	this.setState({ games: _games });
}

function placeBetAmountFragment(shown: boolean, langdata: ILanguageType) {
	if (!shown)
		return null;

	return (
		<div className="bet-amount-message">
			{langdata["txt_place_bet_amount"]}
		</div>
	);
}

export {
	activateBetGroup,

	removeBet,

	activateUnsubmittedTicketRow,
	addUnsubmittedTicketRow,
	fillEmptyUnsubmittedTickets,
	hasUnsubmittedTickets,

	fetchTicketHistory,
	fetchApplyTickets,

	applyTicketRebet,
	countTickets,
	removeTicket,

	placeBetAmountFragment
};
